import { render } from "./offer-declined.vue?vue&type=template&id=0a96efcf"
import script from "./offer-declined.vue?vue&type=script&lang=js"
export * from "./offer-declined.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__